import { Drawer } from 'antd';
import * as React from 'react';
import Context, { drawerProviderActions, Provider } from './context';


interface IDrawerComponentProps {
    children: React.ReactNode
}

const DrawerComponent = ({ children }: IDrawerComponentProps) => {
    const { state, dispatch } = React.useContext(Context);
    const handleClose = () => {
        state.onClose();
        dispatch(drawerProviderActions.resetDrawer());
    };
    return (
        <>
            <Drawer visible={state.open} onClose={handleClose} title={state.title} placement="right" closable={false}
                    width={384} {...state.DrawerProps}>
                {state.content}
            </Drawer>
            {children}
        </>
    );
};

interface IDrawerProviderProps {
    children: React.ReactNode
}

const DrawerProvider = ({ children }: IDrawerProviderProps) => {
    return (
        <Provider>
            <DrawerComponent>
                {children}
            </DrawerComponent>
        </Provider>
    );
};

export default DrawerProvider;
